module.exports = __webpack_public_path__ + "img/new-v.e69a4ea5.svg";